import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { Leave } from '@/features/leave'

const leaveSearchSchema = z.object({
  tab: z.enum(['requests', 'balances']).optional().catch('requests'),
  status: z
    .enum(['pending', 'approved', 'rejected', 'cancelled'])
    .optional()
    .catch(undefined),
  staffId: z.string().optional(),
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(10),
})

export const Route = createFileRoute('/_authenticated/_organization/leave/')({
  component: Leave,
  validateSearch: leaveSearchSchema,
})

